import Vue from 'vue';
import { Button, ButtonGroup, Loading, MessageBox, Message, Dialog, Notification } from 'element-ui';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

import App from './App';
import router from './router';
import store from './store';
import './icons'; // icon
import '@/assets/style/common.less';
import '@/utils/enum';
import 'nprogress/nprogress.css'; // progress bar style
import '@/assets/style/element-variables.scss';


const cloneDeep = require('lodash/cloneDeep');
const eq = require('lodash/eq');
const isEqual = require('lodash/isEqual');

Dialog.props.closeOnClickModal.default = false;

Vue.config.productionTip = false;

Vue.prototype.$ELEMENT = { size: 'medium', zIndex: 3000 };
// 直接挂在全局
window.cloneDeep = cloneDeep;
window.eq = eq;
window.isEqual = isEqual;

Vue.use(Button);
Vue.use(Loading.directive);
Vue.use(ButtonGroup);

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;

// fetch, router里面有用到store，为防止循环引用做此处理
window.$store = store;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

if (process.env.VUE_APP_SENTRY === 'NEED') {
  Sentry.init({
    dsn: 'https://1534edf2c6a140669bf7518d88aaa82a@o392447.ingest.sentry.io/5566511',
    integrations: [new VueIntegration({ Vue, attachProps: true })]
  });
}
